import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnDestroy,
  OnInit, Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatFormFieldAppearance } from "@angular/material/form-field";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { cloneDeep } from "lodash";
import { debounceTime, distinctUntilChanged, filter, Observable, Subscription } from "rxjs";
import { ApplicationService } from "src/app/services/application.service";
import { MyUtils } from "src/app/services/my-utils.service";
import { InputFormModel, IValidator, ObjectFrom, templateType } from "./models/input-form";
import moment from "moment";
@Component({
  selector: "app-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: "it-IT" },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: "wide-custom-select" },
    },
  ],
})
export class DynamicFormComponent implements OnInit, OnDestroy {
  @Input()
  set inputForm(inputForm: ObjectFrom[]) {
    this._inputForm = inputForm;
    this.initForm();
  }
  private _inputForm!: ObjectFrom[];

  get inputForm() {
    return this._inputForm;
  }

  @Input() formGroup!: FormGroup;
  @Input()
  set appearanceForm(appearanceForm: string | undefined) {
    this._appearance = appearanceForm as MatFormFieldAppearance;
  }
  private _appearance: MatFormFieldAppearance = 'fill' as MatFormFieldAppearance;

  get appearance() {
    return this._appearance;
  }

  // TEMPLATE INPUT
  @ViewChild("input") input!: TemplateRef<ViewChild>;
  @ViewChild("searchInput") searchInput!: TemplateRef<ViewChild>;
  @ViewChild("textarea") textarea!: TemplateRef<ViewChild>;
  @ViewChild("dataPicker") datPicker!: TemplateRef<ViewChild>;
  @ViewChild("select") select!: TemplateRef<ViewChild>;
  @ViewChild("selectObject") selectObject!: TemplateRef<ViewChild>;
  @ViewChild("selectGroup") selectGroup!: TemplateRef<ViewChild>;
  @ViewChild("checkBox") checkBox!: TemplateRef<ViewChild>;
  @ViewChild("autocomplete") autocomplete!: TemplateRef<ViewChild>;
  @ViewChild("autocompletemultiple") autocompletemultiple!: TemplateRef<ViewChild>;
  @ViewChild("dataPickerOnlyYearAndMonth") dataPickerOnlyYearAndMonth!: TemplateRef<ViewChild>;
  @ViewChild("inputPercent") inputPercent!: TemplateRef<ViewChild>;
  @ViewChild("autocompleteGroup") autocompleteGroup!: TemplateRef<ViewChild>;
  // TEMPLATE VALIDATOR MESSAGE
  @ViewChild("requiredValidator") requiredValidator!: TemplateRef<ViewChild>;
  @ViewChild("emailValidator") emailValidator!: TemplateRef<ViewChild>;
  @ViewChild("patternValidator") patternValidator!: TemplateRef<ViewChild>;
  @ViewChild("autocompleteWithButton") autocompleteWithButton!: TemplateRef<ViewChild>;
  @ViewChild("radioButtonList") radioButtonList!: TemplateRef<ViewChild>;

  formGroupAutocomplete: FormGroup<{ [key: string]: FormControl }>;

  lanSubscription?: Subscription;
  translationSubscription?: Subscription;
  private autocompleteControlSubscriptions: Subscription[] = [];

  constructor(
    private applicationService: ApplicationService,
    private cdref: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public utils: MyUtils,
    private adapter: DateAdapter<Date>
  ) {
    this.formGroupAutocomplete = this.formBuilder.group({});

    this.lanSubscription = this.applicationService.languageSelect
      .pipe(filter((lan) => !!lan))
      .subscribe((lan) => {
        lan = lan === 'at-AT' ? 'de-DE' : lan

        this.adapter.setLocale(moment.locale(lan));

      });
  }

  ngOnInit() {
    this.translationSubscription = this.applicationService.translationListSelect
      .pipe(filter((trad) => !trad.loader))
      .subscribe((_) => {
        this.cdref.detectChanges();
      });
  }

  ngOnDestroy() {
    this.lanSubscription?.unsubscribe();
    this.translationSubscription?.unsubscribe();
    this.clearAutocompleteControlSubscriptions();
  }

  refreshView() {
    this.cdref.markForCheck();
    this.cdref.detectChanges();
  }

  private _filterGroup(name: any, i: number, j: number) {
    if (typeof name === "string") {
      const filterValue = name.toUpperCase();
      let key = this.inputForm[i][j].viewValueSelect!;
      let fatherKeyTraslate = this.inputForm[i][j].fatherKeyTraslate;

      let filter: any = [];
      this.inputForm[i][j].objectSelectBK?.forEach((item) => {
        let obj = item.value.filter((option: any) =>
          option.key.toUpperCase().includes(filterValue)
        );

        filter.push({ title: item.title, value: obj });
      });
      this.inputForm[i][j].objectSelect = filter;
    }
  }

  private _filter(name: any, i: number, j: number) {
    if (typeof name === "string") {
      const filterValue = name.toLowerCase();
      let key = this.inputForm[i][j].viewValueSelect!;
      let fatherKeyTraslate = this.inputForm[i][j].fatherKeyTraslate;
      this.inputForm[i][j].objectSelect = this.inputForm[i][j].objectSelectBK!.filter(
        (option: any) =>
          this.utils
            .traslatei18n(option[key] ? option[key] : key, fatherKeyTraslate)
            .toLowerCase()
            .includes(filterValue)
      );
    }
  }

  private initForm() {
    this.clearAutocompleteControlSubscriptions();
    this.inputForm.map((row, i) => {
      row.map((element, j) => {
        switch (element.template) {
          case "autocompleteGroup":
            {
              if (!element.objectSelectBK) {
                element.objectSelectBK = element.objectSelect;
              }
              const control = this.getOrCreateAutocompleteControl(element.formControlName);
              this.autocompleteControlSubscriptions.push(control.valueChanges
                .pipe(
                  filter((val) => !element.waitFilter || !val || val.length >= element.waitFilter)
                )
                .subscribe((data: any) => {
                  this._filterGroup(data, i, j);
                }));
            }

            break;
          case "autocomplete":
            {
              if (!element.objectSelectBK) {
                element.objectSelectBK = element.objectSelect;
              }
              if (
                element.valueBK &&
                element.valueBK.length > 0 &&
                element.valueBK.length === element.objectSelectBK?.length
              ) {
                element.selectAll = true;
              }
              const control = this.getOrCreateAutocompleteControl(element.formControlName);
              let valueChanges: Observable<any> = control.valueChanges
                .pipe(filter((val) => !element.waitFilter || !val || val.length >= element.waitFilter));

              if (element.lazyLoad) {
                valueChanges = valueChanges.pipe(debounceTime(300), distinctUntilChanged());
              }

              this.autocompleteControlSubscriptions.push(valueChanges.subscribe((data: any) => {
                if (element.lazyLoad) {
                  element.onSearchChange?.(data || "");
                  this.cdref.markForCheck();
                  return;
                }

                this._filter(data, i, j);
              }));
            }

            break;
          case "autocompleteWithButton":
            {
              const buttonControlName = "button" + element.formControlName;
              if (!this.formGroup.contains(buttonControlName)) {
                this.formGroup.addControl(buttonControlName, new FormControl());
              }
              if (!element.objectSelectBK) {
                element.objectSelectBK = element.objectSelect;
              }
              const control = this.getOrCreateAutocompleteControl(element.formControlName, true);
              this.autocompleteControlSubscriptions.push(control.valueChanges
                .pipe(
                  filter((val) => !element.waitFilter || !val || val.length >= element.waitFilter)
                )
                .subscribe((data: any) => {
                  this._filter(data, i, j);
                }));
            }

            break;

          default:
            break;
        }
      });
    });
    this.cdref.detectChanges();
  }

  private getOrCreateAutocompleteControl(formControlName: string, defaultValue: any = null): FormControl {
    const existingControl = this.formGroupAutocomplete.get(formControlName) as FormControl | null;
    if (existingControl) {
      return existingControl;
    }

    this.formGroupAutocomplete.addControl(formControlName, new FormControl(defaultValue));
    return this.formGroupAutocomplete.controls[formControlName];
  }

  private clearAutocompleteControlSubscriptions() {
    this.autocompleteControlSubscriptions.forEach((subscription) => subscription.unsubscribe());
    this.autocompleteControlSubscriptions = [];
  }

  updateMySelection(element: any, formControlName: any) {
    this.formGroup.controls[formControlName].setValue(element);
  }
  /*   ngOnChange(a: any) {
    this.appearance = this.appearanceForm as MatFormFieldAppearance;
  } */

  /*   ngAfterContentChecked() {
    this.cdref.detectChanges();
  } */

  selectTemplate(template: templateType): any {
    switch (template) {
      case "input":
        return this.input;
      case "textarea":
        return this.textarea;
      case "dataPicker":
        return this.datPicker;
      case "select":
        return this.select;
      case "selectObject":
        return this.selectObject;
      case "selectGroup":
        return this.selectGroup;
      case "checkBox":
        return this.checkBox;
      case "autocomplete":
        return this.autocomplete;
      case "autocompletemultiple":
        return this.autocompletemultiple;
      case "dataPickerOnlyYearAndMonth":
        return this.dataPickerOnlyYearAndMonth;
      case "inputPercent":
        return this.inputPercent;
      case "autocompleteGroup":
        return this.autocompleteGroup;
      case "autocompleteWithButton":
        return this.autocompleteWithButton;
      case "radioButtonList":
        return this.radioButtonList
      case "searchInput":
        return this.searchInput
      default:
        break;
    }
  }

  objectKey(validators: IValidator) {
    return Object.keys(validators);
  }
  selectValidator(validator: string): any {
    switch (validator) {
      case "required":
        return this.requiredValidator;
      case "email":
        return this.emailValidator;
      case "pattern":
        return this.patternValidator;

      default:
        break;
    }
  }
  selectElementAutocomplete(event: any, element: InputFormModel) {
    if (event.isUserInput) {
      if (!element.valueBK || element.valueBK.length === 0) {
        element.selectAll = true;

        element.valueBK = this.formGroup.controls[element.formControlName].value
          ? this.formGroup.controls[element.formControlName].value
          : element.isMultipleSelect
            ? []
            : null;

        if (event.source.selected) {
          element.isMultipleSelect
            ? element.valueBK.push(event.source.value)
            : (element.valueBK = event.source.value);
        } else {
          let b = element.isMultipleSelect
            ? element.valueBK.filter((item: any) => item !== event.source.value)
            : null;
          element.valueBK = b;
        }
      } else {
        if (
          element.valueBK &&
          element.valueBK.length > 0 &&
          element.valueBK.length === element.objectSelectBK?.length
        ) {
          element.selectAll = true;
        }

        if (event.source.selected) {
          element.isMultipleSelect
            ? element.valueBK.push(event.source.value)
            : (element.valueBK = event.source.value);
        } else {
          if (
            element.isMultipleSelect &&
            element.formControlName === 'brand'
          ) {
            const currentVal: any[] = element.valueBK || this.formGroup.controls[element.formControlName].value || [];
            if (Array.isArray(currentVal) && currentVal.length === 1 && currentVal[0] === event.source.value) {
              try {
                event.source.select();
              } catch (e) { }
              this.formGroup.get(element.formControlName)?.setValue(currentVal);
              return;
            }
          }

          let b = element.isMultipleSelect
            ? element.valueBK.filter((item: any) => item !== event.source.value)
            : null;
          element.valueBK = b;
        }
        this.formGroup.get(element.formControlName)?.setValue(element.valueBK);
      }
    }
  }

  selectElementAutocompleteGroup(event: any, element: any) {
    if (event.isUserInput) {
      if (!element.valueBK || element.valueBK.length === 0) {
        element.valueBK = this.formGroup.controls[element.formControlName].value
          ? this.formGroup.controls[element.formControlName].value
          : element.isMultipleSelect
            ? []
            : null;
        if (event.source.selected) {
          element.isMultipleSelect
            ? element.valueBK.push(event.source.value)
            : (element.valueBK = event.source.value);
        }
      } else {
        if (event.source.selected) {
          element.isMultipleSelect
            ? element.valueBK.push(event.source.value)
            : (element.valueBK = event.source.value);
        } else {
          if (
            element.isMultipleSelect &&
            element.formControlName === 'brand'
          ) {
            const currentVal: any[] = element.valueBK || this.formGroup.controls[element.formControlName].value || [];
            if (Array.isArray(currentVal) && currentVal.length === 1 && currentVal[0] === event.source.value) {
              try {
                event.source.select();
              } catch (e) { }
              this.formGroup.controls[element.formControlName].setValue(currentVal);
              return;
            }
          }

          let b = element.isMultipleSelect
            ? element.valueBK.filter((item: any) => item !== event.source.value)
            : null;
          element.valueBK = b;
        }
      }
      this.formGroup.controls[element.formControlName].setValue(element.valueBK);
    }
  }

  setAll(element: InputFormModel) {
    let all = element.objectSelect?.map((el) => el[element.keySelect || ""]);
    this.formGroup.controls[element.formControlName].setValue(all);
    this.formGroupAutocomplete.controls[element.formControlName].setValue("");
    element.valueBK = all;
    element.value = all;
  }
  clearAll(element: InputFormModel) {
    element.selectAll = false;
    // Default behavior: reset to empty array (for multiple) or empty string
    let resetValue: any = element.isMultipleSelect ? cloneDeep([]) : "";

    // Special handling for the 'brand' control: ensure at least one brand stays selected
    // In the network-controls `BrandCtrl` we may have a `defaultBrand` or special semantics
    try {
      const ctrlName: any = element.formControlName;
      if (ctrlName === 'brand' && element.isMultipleSelect) {
        const maybeDefault = (element as any).defaultBrand;
        if (maybeDefault && maybeDefault !== '#') {
          resetValue = [maybeDefault];
        } else {
          const bk: any[] = element.objectSelectBK || [];
          const firstKey = bk.length > 0 ? (bk[0].key ?? undefined) : undefined;
          if (firstKey) {
            resetValue = [firstKey];
          } else {
            resetValue = [];
          }
        }
      }
    } catch (e) {
    }

    this.formGroup.controls[element.formControlName].setValue(resetValue);
    this.formGroupAutocomplete.controls[element.formControlName].setValue("");
    element.valueBK = resetValue;
    element.value = resetValue;
    element.objectSelect = element.objectSelectBK;
    //this.formGroup.controls[element.formControlName].setValue(element.valueBK);
  }
  closePannelSelect(event: any, element: any) {
    if (event) {
      // Panel opened: restore full list and clear the search input
      this.formGroupAutocomplete.controls[element.formControlName].setValue(null, {
        emitEvent: !element.lazyLoad,
      });
      element.objectSelect = element.objectSelectBK;
    } else {
      // Panel closed: narrow objectSelect to only the selected item(s) so that
      // cdk-virtual-scroll renders it and mat-select can find it via @ContentChildren,
      // keeping mat-select.empty = false and the floating label in the correct position
      const currentValue = this.formGroup.get(element.formControlName)?.value;
      const bk: any[] = element.objectSelectBK ?? [];
      if (currentValue !== null && currentValue !== undefined && currentValue !== '' && bk.length && element.keySelect) {
        let filtered: any[];
        if (element.isMultipleSelect && Array.isArray(currentValue) && currentValue.length > 0) {
          filtered = bk.filter((o: any) => (currentValue as any[]).includes(o[element.keySelect]));
        } else {
          filtered = bk.filter((o: any) => o[element.keySelect] === currentValue);
        }
        element.objectSelect = filtered.length > 0 ? filtered : bk;
      } else {
        element.objectSelect = bk;
      }
    }
  }

  onAutocompleteScroll(index: number, element: InputFormModel) {
    const totalOptions = element.objectSelect?.length || 0;
    if (!element.lazyLoad || element.loading || !element.hasMore || totalOptions === 0) {
      return;
    }

    const prefetchThreshold = Math.max(20, Math.ceil(totalOptions * 0.25));
    if (index >= Math.max(totalOptions - prefetchThreshold, 0)) {
      element.onLazyLoad?.();
      this.cdref.markForCheck();
    }
  }

  applyAutocomplate(element: any) {
    this.formGroup.controls["button" + element.formControlName].setValue(true);
  }

  sectionAllowed(sectionSet: string[] | undefined) {
    const actualSection = this.applicationService.navBarSelectValue?.idItem;
    return !sectionSet?.length || sectionSet.includes(actualSection)
  }

  getAutocompleteDisplayValue(item: InputFormModel, value: any): string {
    if (value === null || value === undefined || value === '') return '';
    const bk: any[] = (item.objectSelectBK ?? item.objectSelect) as any[] ?? [];
    if (item.isMultipleSelect && Array.isArray(value)) {
      return value.map((v: any) => {
        const opt = bk.find((o: any) => o[item.keySelect!] === v);
        return opt
          ? this.utils.traslatei18n(opt[item.viewValueSelect!] ?? v, item.fatherKeyTraslate)
          : String(v);
      }).join(', ');
    }
    const opt = bk.find((o: any) => o[item.keySelect!] === value);
    return opt
      ? this.utils.traslatei18n(opt[item.viewValueSelect!] ?? value, item.fatherKeyTraslate)
      : String(value);
  }
}
